import React from 'react';
import './guide_logo.scss';
import { FormattedMessage } from 'react-intl';

export default class CoverGuideLogo extends React.Component {
  static displayName = 'CoverGuideLogo';

  render() {
    return (
      <div className="CoverGuideLogo">
        <img src={this.props.picture} className="guide-logo" />
        <span className="text">
          <span className="title">
            <span className="name">{this.props.tourName}</span>
          </span>
          <span className="guide">
            <FormattedMessage
              id="WITH_NAME"
              defaultMessage="With {name}"
              values={{ name: this.props.guideName }}
            />
          </span>
        </span>
      </div>
    );
  }
}
